/** venture/CoStatChips.tsx — 단계 헤더의 회사별 상태 표시 (읽기 전용, 2026-09-24)
 *  「헤더는 읽는 곳, 카드는 바꾸는 곳」. 4곳 이하면 이름+상태 칩, 5곳 이상이면 숫자로 접는다.
 *  칩을 누르면 그 회사 카드로 스크롤할 뿐, 상태는 바꾸지 않는다(상태 변경은 카드 안 CoStatBar). */
import React from 'react';
import { cosOf, coStat, rollup } from './costep';
import type { Stat } from './costep';
import type { Project } from './types';

const KO: Record<Stat, string> = { wait: '대기', cur: '진행', done: '완료' };
const CLS: Record<Stat, string> = { wait: 'p-gray', cur: 'p-amber', done: 'p-green' };

export function scrollToCo(coId: string, n: number): void {
  const el = document.getElementById('co-' + coId + '-' + n);
  if (el) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
}

export default function CoStatChips({ p, n, onJump }: { p: Project; n: number; onJump?: (coId: string) => void }) {
  const cos = cosOf(p);
  if (!cos.length) return null;
  if (cos.length > 4) {
    const r = rollup(p, n);
    return (
      <span className="cochips">
        {r.done ? <span className="pill p-green">완료 {r.done}</span> : null}
        {r.cur ? <span className="pill p-amber">진행 {r.cur}</span> : null}
        {r.wait ? <span className="pill p-gray">대기 {r.wait}</span> : null}
      </span>
    );
  }
  return (
    <span className="cochips">
      {cos.map((co) => {
        const st = coStat(p, co.id, n);
        return (
          <button type="button" key={co.id} className={'pill cochip ' + CLS[st]} title="카드로 이동"
            onClick={(e) => { e.stopPropagation(); if (onJump) onJump(co.id); else scrollToCo(co.id, n); }}>
            <span className="nm">{co.name || '(법인)'}</span> {KO[st]}
          </button>
        );
      })}
    </span>
  );
}
